<template>
  <nav class="war-room-post-breadcrumbs">
    <div v-for="({ name, route, tag }, index) in crumbs" :key="name" class="war-room-post-breadcrumbs__crumb">
      <NuxtLink
        v-if="route"
        :to="route"
        data-test="posts_breadcrumb"
        class="war-room-post-breadcrumbs__name"
        :class="{ 'war-room-post-breadcrumbs__link': route }"
      >
        {{ name }}
      </NuxtLink>
      <Component :is="tag || 'span'" v-else class="war-room-post-breadcrumbs__name">
        {{ name }}
      </Component>
      <ArrowRightIcon v-if="index + 1 < crumbs.length" class="war-room-post-breadcrumbs__arrow" />
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import ArrowRightIcon from './images/arrow-right.vue.svg';
import { WAR_ROOM_POSTS_TAB_MYFEED_PAGE } from '@/constants/';
import { categoryData } from '~/components/partials/war-room/WarRoomPostForm/WarRoomPostFormCategories/constants';

export default {
  name: 'WarRoomPostBreadcrumbs',
  components: { ArrowRightIcon },
  props: {
    post: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters('warRoom', ['topics']),
    postCrumbs() {
      const category = {
        name: this.post.category.title,
        route: { name: 'war-room-categories-categorySlug-posts', params: { categorySlug: this.post.category.slug } },
      };

      const post = {
        name: 'Post',
      };

      return [category, post];
    },
    topicCrumbs() {
      const currentTopic = this.topics.find(({ slug }) => slug === this.$route.params.topicSlug);

      const topic = {
        name: `${currentTopic.emoji} ${currentTopic.name}`,
        tag: 'h1',
      };

      return [topic];
    },
    categoryCrumbs() {
      const currentCategory = categoryData[this.$route.params.categorySlug];

      const category = {
        name: currentCategory.title,
        tag: 'h1',
      };

      return [category];
    },
    crumbs() {
      let crumbs;

      switch (this.$route.name) {
        case 'war-room-categories-categorySlug-posts':
          crumbs = this.categoryCrumbs;
          break;
        case 'war-room-topics-topicSlug-posts':
          crumbs = this.topicCrumbs;
          break;
        case 'war-room-posts-slug':
          crumbs = this.postCrumbs;
          break;
        default:
          crumbs = this.postCrumbs;
      }

      return [
        {
          name: 'The War Room',
          route: WAR_ROOM_POSTS_TAB_MYFEED_PAGE,
        },
        ...crumbs,
      ];
    },
  },
};
</script>

<style scoped lang="scss">
.war-room-post-breadcrumbs {
  display: flex;
  flex-direction: row;

  &__crumb {
    @include subhead;

    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: 600;
    color: var(--gray-50);
  }

  &__name {
    @include inherit-font;

    padding: 0;
    margin: 0;
    text-decoration: none;
  }

  &__link:hover {
    text-decoration: underline;
  }

  &__arrow {
    flex-shrink: 0;
    margin: 0 5px;
    color: var(--gray-50);
  }
}
</style>
